export default __webpack_public_path__ + "static/media/srihari.dc96f625.jpg";